import { render, staticRenderFns } from "./EnterpriseResources.vue?vue&type=template&id=15f0cfe8&scoped=true"
import script from "./EnterpriseResources.vue?vue&type=script&lang=js"
export * from "./EnterpriseResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f0cfe8",
  null
  
)

export default component.exports